import { useEffect, useState } from 'react'
import useFetch from '../../hooks/useFetch'
import usePermissions from '../../hooks/usePermissions'
import { urlApi, DIAS, MESES } from '../../config'
import WhatsAppIcon from '@mui/icons-material/WhatsApp'
import LoadingIndicator from '../LoadingIndicator'
import WhatsAppComposer from '../WhatsAppComposer'
import { whatsappLink } from '../../utils/whatsappTemplates'

export default function UserInfoPopup({ userId, lobby }) {
  const [composerOpen, setComposerOpen] = useState(false)
  const { loading, data } = useFetch(`${urlApi}/admin/users/id/${userId}`)
  const { hasAnyPermission } = usePermissions()
  const canSendWhatsApp = hasAnyPermission('edit-user', 'channels')

  const [createdTime, setCreatedTime] = useState('')
  const [createdDate, setCreatedDate] = useState('')
  const [lastTime, setLastTime] = useState('')
  const [lastDate, setLastDate] = useState('')

  useEffect(() => {
    if (!loading) {
      const createdDateTime = new Date(new Date(data.created).getTime() - 3 * 60 * 60 * 1000)
      setCreatedTime(
        createdDateTime.toISOString().substr(createdDateTime.toISOString().indexOf('T') + 1, 5)
      )
      setCreatedDate(
        DIAS[createdDateTime.getDay()] +
          ' ' +
          createdDateTime.getDate() +
          ' de ' +
          MESES[createdDateTime.getMonth()]
      )
      const lastDateTimeInUruguay = new Date(
        new Date(data.last_login).getTime() - 3 * 60 * 60 * 1000
      ).toISOString()
      setLastTime(lastDateTimeInUruguay.substr(lastDateTimeInUruguay.indexOf('T') + 1, 5))
      setLastDate(
        DIAS[new Date(data.last_login).getDay()] +
          ' ' +
          new Date(data.last_login).getDate() +
          ' de ' +
          MESES[new Date(data.last_login).getMonth()]
      )
      if (data.user_metadata.first_name) {
        data.user_metadata.first_name = data.user_metadata.first_name.trim()
      }
      if (data.user_metadata.phone_number && data.user_metadata.phone_number.charAt(0) != '+') {
        data.user_metadata.phone_number =
          '+598' +
          data.user_metadata.phone_number.substring(1, data.user_metadata.phone_number.length)
      }
    }
  }, [loading])
  //Calculate age with data.user_metadata.birthdate
  const age = () => {
    const birthdate = new Date(data.user_metadata.birthdate)
    const today = new Date()
    let age = today.getFullYear() - birthdate.getFullYear()
    const month = today.getMonth() - birthdate.getMonth()
    if (month < 0 || (month === 0 && today.getDate() < birthdate.getDate())) {
      age--
    }
    return age
  }

  const openWhatsApp = () => {
    if (canSendWhatsApp) setComposerOpen(true)
    else window.open(whatsappLink(data.user_metadata.phone_number))
  }

  if (loading) {
    return (
      <div className='h-ful w-full flex justify-center items-center'>
        <LoadingIndicator />
      </div>
    )
  }

  return (
    <div className='h-ful w-full'>
      <div className='h-ful w-full'>
        <div className='flex flex-col justify-center mb-3'>
          <div className='flex justify-center'>
            <img
              className='rounded-full mt-3 max-w-[95px] max-h-[95px]'
              src={data.picture}
              width='95px'
              height='95px'
            />
          </div>
          {data.user_metadata.gender != 'Hombre' && data.user_metadata.gender != 'Mujer' && (
            <div className='flex m-auto text-2xl my-2 text-purple-900 dark:text-purple-300'>
              <p className='font-bold mr-1'>GENERO: {data.user_metadata.gender}</p>
            </div>
          )}
          <p
            onClick={() => {
              window.open(
                `${window.location.origin}?navigation=UserSearch&user_id=${userId}`,
                '_blank'
              )
            }}
            className='text-base text-center font-bold text-light_coral cursor-pointer my-2'
          >
            Abrir perfil completo
          </p>
          <div className='flex m-auto'>
            <p className='font-bold mr-1'>Nombre:</p> {data.user_metadata.first_name}
          </div>
          <div className='flex m-auto'>
            <p className='font-bold mr-1'>Apellido:</p> {data.user_metadata.last_name}
          </div>
          <div className='flex m-auto'>
            <p className='font-bold mr-1'>
              Tel:{' '}
              <a
                className='text-blue-600 dark:text-blue-400 cursor-pointer'
                onClick={openWhatsApp}
              >
                {data.user_metadata.phone_number}
              </a>
              <WhatsAppIcon
                className='cursor-pointer text-green-600 dark:text-emerald-400'
                onClick={openWhatsApp}
              />
            </p>
          </div>
          <div className='flex m-auto'>
            <p className='font-bold mr-1'>Email: </p> {data.email}
          </div>
          {data?.user_metadata?.preferences && (
            <div className='flex m-auto'>
              <p className='font-bold mr-1'>Preferencias:</p>{' '}
              {data.user_metadata.preferences.map(x => x + ' | ')}
            </div>
          )}
          {data?.user_metadata?.biography && (
            <div className='w-full flex justify-center'>
              <div className='w-[400px] flex m-auto'>
                <p className='font-bold'>Biografía:</p>
                {data.user_metadata.biography}
              </div>
            </div>
          )}
          <div className='flex m-auto'>
            <p className='font-bold mr-1'>Edad: </p>
            {age()}
          </div>
          <div className='flex m-auto'>
            <p className='font-bold mr-1'>Registrado:</p> {createdDate} {createdTime}
          </div>
          <div className='flex m-auto'>
            <p className='font-bold mr-1'>Ultima vez:</p> {lastDate} {lastTime}
          </div>
          <div className='flex flex-col items-center gap-2 m-auto'>
            <div className='flex'>
              <p className='font-bold mr-1'>ID:</p> {data.user_id}
            </div>
            <button
              onClick={() => {
                window.open(
                  `https://mixpanel.com/project/2806693/view/3341141/app/profile#distinct_id=${data.user_id}`,
                  '_blank'
                )
              }}
              className='bg-purple-600 hover:bg-purple-700 text-white px-3 py-1 rounded text-sm font-medium transition-colors'
            >
              Abrir en Mixpanel
            </button>
          </div>
        </div>
      </div>
      <WhatsAppComposer
        open={composerOpen}
        onClose={() => setComposerOpen(false)}
        user={{
          user_id: data.user_id,
          first_name: data.user_metadata.first_name,
          phone_number: data.user_metadata.phone_number
        }}
        lobby={lobby || undefined}
      />
    </div>
  )
}
